import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_branch_label_list_RowClass } from '../../../dbschema';

export class BranchLabelListContainerModel extends BaseContainerModel {
  bl_fi_branch_label_list: bl_fi_branch_label_list_RowClass = new bl_fi_branch_label_list_RowClass();
}